import { useState, useEffect } from 'react';
import Presenter from './StatisticsPresenter';
import { axiosCustom } from '../../../common/common.function';
import { IMemberProps } from '../../../common/interface/props';
import XLSX from 'xlsx';
import Swal from 'sweetalert2';

export default function Container({ solType }: IMemberProps) {
  const [allWeekData, setAllWeekData] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      visitor: 0,
      joinSeller: 0,
      migrationProd: 0,
      migrationSellerFirst: 0,
      migrationSeller: 0,
      prodAvgSeller: 0,
      successPercent: 0,
    },
  ]); // 주간 전체 데이터
  const [allDataSum, setAllDataSum] = useState([
    {
      visitor: 0,
      joinSeller: 0,
      migrationProd: 0,
      migrationSellerFirst: 0,
      migrationSeller: 0,
      prodAvgSeller: 0,
      successPercent: 0,
    },
  ]); // 전체합산 통계 데이터

  const [lastUpdate, setLastUpdate] = useState('0000-00-00 00:00:00'); // 마지막 업데이트 일

  const toDay = new Date();
  const yesterday = new Date(toDay.setDate(toDay.getDate() - 1));
  const year = yesterday.getFullYear(); // 년, 2015
  const month = yesterday.getMonth() + 1; // 월, 11[1을 더해야함. 유일하게 조심해야할 부분. 1월은 0이다.]
  const date = yesterday.getDate(); // 일, 14
  const yesterDay = `${year}-${month}-${date}`;

  //백엔드 wakeup commob DB statistics_week Table에 저장된 주간 통계 자료 가져오기
  useEffect(() => {
    async function fetchData() {
      const { result } = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/admin/statistics`, {
        solType: solType,
      });
      setLastUpdate(result.lastUpdate); // 마지막 업데이트일
      setAllWeekData(result.weekData); // 전체 데이터
      setAllDataSum(result.allData); // 전체 통계 데이터
    }
    fetchData();
  }, []);

  const columns = {
    날짜: '',
    '가입 셀러': '플레이오토 신규 회원가입 수',
    '이전 성공 상품 수': '주당 상품 이전 성공한 상품 수 (실패건수 미포함)',
    '첫 이전 성공 셀러': '주당 상품 이전 최초 성공한 셀러 수',
    '이전 성공 셀러': '주당 상품 이전 성공한 셀러 수',
    '셀러당 평균 이전 성공 상품 수': '주당 상품 이전 이용한 셀러별 평균 성공 상품 수 (이전 성공 상품 수 / 이전 성공 셀러)',
    '상품 이전 성공 비율': '주당 상품 이전 성공 비율 ((이전 성공 상품 수 / 이전 전체 상품 수) * 100)',
  };

  //const columns = ['날짜', '가입 셀러', '이전 성공 상품 수', '첫 이전 성공 셀러', '이전 성공 셀러', '셀러당 평균 이전 성공 상품 수', '상품 이전 성공 비율'];

  const rows = [
    allWeekData.map((one, index): any => ({
      id: index,
      day: `${one.startDate} ~ ${one.endDate}`,
      // visitorCount: one.visitor.toLocaleString(), //방문자수
      joinSellerCount: one.joinSeller.toLocaleString(), //서비스가입 셀러
      prodCount: one.migrationProd.toLocaleString(), //총 상품 수
      migrationFirstSellerCount: one.migrationSellerFirst.toLocaleString(), //상품 첫 이전 셀러 수
      migrationSellerCount: one.migrationSeller.toLocaleString(), //상품 이전 셀러 수
      sellerAverageProdCount: one.prodAvgSeller.toFixed().toLocaleString(), //셀러당 평균 상품 수
      successRate: `${one.successPercent.toLocaleString()}%`, //상품 별 성공비율
    })),
  ];

  const allDataSumColumns = {
    '가입 셀러': '플레이오토 신규 회원가입 수',
    '이전 성공 상품 수': '전체 상품 이전 성공한 상품 수 (실패건수 미포함)',
    '첫 이전 성공 셀러': '전체 상품 이전 최초 성공한 셀러 수',
    '이전 성공 셀러': '전체 상품 이전 성공한 셀러 수',
    '셀러당 평균 이전 성공 상품 수': '전체 상품 이전 이용한 셀러별 평균 성공 상품 수 (이전 성공 상품 수 / 이전 성공 셀러)',
    '상품 이전 성공 비율': '전체 상품 이전 성공 비율 ((이전 성공 상품 수 / 이전 전체 상품 수) * 100)',
  };
  //const allDataSumColumns = ['가입 셀러', '이전 성공 상품 수', '첫 이전 성공 셀러', '이전 성공 셀러', '셀러당 평균 이전 성공 상품 수', '상품 이전 성공 비율'];

  const allDataSumData = {
    // visitorCountAll: allDataSum[0].visitor.toLocaleString(), //방문자수
    joinSellerCountAll: allDataSum[0].joinSeller.toLocaleString(), //서비스가입 셀러
    prodCountAll: allDataSum[0].migrationProd.toLocaleString(), //총 상품 수
    migrationFirstSellerCountAll: allDataSum[0].migrationSellerFirst.toLocaleString(), //상품 첫 이전 셀러 수
    migrationSellerCountAll: allDataSum[0].migrationSeller.toLocaleString(), //상품 이전 셀러 수
    sellerAverageProdCountAll: allDataSum[0].prodAvgSeller.toFixed().toLocaleString(), //셀러당 평균 상품 수
    successRateAll: `${allDataSum[0].successPercent.toLocaleString()}%`, //상품 별 성공비율
  };

  // 쇼핑몰 이름 변환
  function convertShopName(name: string) {
    switch (name) {
      case 'ALL':
        return '웨이크업 통합';
      case 'ST11':
        return '11번가';
      case 'COUPANG':
        return '쿠팡';
      case 'KAKAO':
        return '카카오';
      case 'WEMAKEPRICE':
        return '위메프';
      case 'ALWAYZ':
        return '올웨이즈';
    }
  }

  // 엑셀 다운로드
  async function excelDownloadEvent() {
    Swal.fire({
      title: '잠시만 기다려 주세요.',
      html: '주간 통계 상세 다운로드 ...', // add html attribute if you want or remove
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    const excelData = rows[0].map((one): any => {
      return {
        day: one.day,
        joinSellerCount: parseInt(one.joinSellerCount.replace(',', '')),
        prodCount: parseInt(one.prodCount.replace(',', '')),
        migrationFirstSellerCount: parseInt(one.migrationFirstSellerCount.replace(',', '')),
        migrationSellerCount: parseInt(one.migrationSellerCount.replace(',', '')),
        sellerAverageProdCount: parseInt(one.sellerAverageProdCount.replace(',', '')),
        successRate: one.successRate,
      };
    });
    const titleName = `${convertShopName(solType)} 주간 통계`;

    const dataWS = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, dataWS, titleName);

    // 헤더 설정
    XLSX.utils.sheet_add_aoa(
      dataWS,
      [['날짜', '가입 셀러', '이전 성공 상품 수', '첫 이전 성공 셀러', '이전 성공 셀러', '셀러당 평균 이전 성공 상품 수 ', '상품 이전 성공 비율']],
      { origin: 'A1' },
    );

    // 너비 지정
    dataWS['!cols'] = [24, 10, 17, 17, 17, 27, 18].map((one) => {
      return { wch: one };
    });

    // 숫자형식으로 셀 서식 변경
    // fmt를 #,##0 으로 하면 통화 형식으로 변경 됨
    const fmt = '0';
    const range = XLSX.utils.decode_range(dataWS['!ref'] || '');
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell = dataWS[XLSX.utils.encode_cell({ r: R, c: C })];
        if (!cell || cell.t !== 'n') continue;
        cell.z = fmt;
      }
    }

    XLSX.writeFile(wb, `${titleName}.xlsx`);
    Swal.close();
  }

  return (
    <>
      <Presenter
        excelDownloadEvent={excelDownloadEvent}
        yesterDay={yesterDay}
        allDataSumColumns={allDataSumColumns}
        allDataSumData={allDataSumData}
        columns={columns}
        rows={rows[0]}
      />
    </>
  );
}
